export default __webpack_public_path__ + "static/media/bg-pattern-intro-web.0b6766bb.svg";